<script setup lang="ts">
import type { InteractionPreviewProps } from '../../../../model/assessments/preview-interactions.hook'

import { AppText } from '@shared/ui/typography'

import { usePreviewWhiteboard } from '../../../../model/assessments/preview-interactions.hook'
import { useAssessmentMediaSrc } from '../../../../model/assessments/media-asset.hook'

/**
 * The whiteboard's background, if one is authored, and a stated drawing area — the surface itself
 * is not reproduced (§A-10). `backgroundAsset.url` may be an external URL or an uploaded path, so
 * the `src` comes from `useAssessmentMediaSrc`. Absent, still resolving, and unsignable each get
 * their own line, never a broken image icon.
 */
defineOptions({
  name: 'PreviewWhiteboard',
})

const props = defineProps<InteractionPreviewProps>()

const {
  refBackgroundUrl,
  refHasBackground,
  refBackgroundAlt,
} = usePreviewWhiteboard(() => props.interaction)

const {
  refSrc,
  refIsResolving,
  refError,
} = useAssessmentMediaSrc(() => refBackgroundUrl.value)
</script>

<template>
  <div class="preview-whiteboard">
    <div class="preview-whiteboard__canvas">
      <img
        v-if="refSrc"
        class="preview-whiteboard__background"
        :src="refSrc"
        :alt="refBackgroundAlt"
      >
      <AppText
        v-else
        name="body2"
        color="slate-500"
      >
        <template v-if="!refHasBackground">
          No background image set.
        </template>
        <template v-else-if="refIsResolving">
          Background image — loading…
        </template>
        <template v-else>
          Background image — {{ refError ?? 'could not be loaded' }}
        </template>
      </AppText>

      <AppText
        name="body2"
        color="slate-500"
      >
        Drawing area — the kid draws here.
      </AppText>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./PreviewWhiteboard.scss" />
